import { contactSubmissionFormLoader } from '../../rankers/components/contact_submission_form/contact_submission_form_loader';
contactSubmissionFormLoader();
